<template>

    <div class="layout__padding-clear layout__width-90">
        <div class="text__align-center text__colour-teal layout__padding-40px-0">
            <h2>Contact Us</h2>
        </div>

        <div class="layout__margin__bottom-30">
            <div class="component__columns-2">
                <!--<iframe class="component__map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2287.2929404437377!2d-1.5858670838170774!3d55.02055828036381!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487e736f37bdbf9b%3A0x773a76e51e6f23ac!2sRavensworth+Printing+Services+Limited!5e0!3m2!1sen!2suk!4v1530783051363"
                        allowfullscreen=""></iframe>-->
                <!--<iframe class="component__map"
                        src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d2282.8408761265196!2d-1.6137009835929497!3d55.09855039972597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s2%20Arcot%20Court%2C%20Nelson%20Road%2C%20Cramlington%2C%20Northumberland%20NE23%201BB!5e0!3m2!1sen!2suk!4v1606301619979!5m2!1sen!2suk!4v1530783051363"
                        allowfullscreen=""></iframe>-->
                <iframe class="component__map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d617.6613370001488!2d-1.1958074302723705!3d51.739521828704106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876c1a03ec832c9%3A0x61ee06f9254c1ea9!2s29%20Pony%20Rd%2C%20Oxford%20OX4%202RD!5e0!3m2!1sen!2suk!4v1769788639153!5m2!1sen!2suk"
                        allowfullscreen=""></iframe>
                <h3 class="text__colour-teal layout__padding__top-20px">Ravensworth</h3>
                <p>
                    Units 29-32 <br>
                    Horspath Industrial Estate <br>
                    Oxford <br>
                    OX4 2RD <br><br>
                </p>
            </div>

            <div class="component__columns-2">

                <h4 class="layout__padding__bottom-6px">For all design and print requests, questions, concerns or to order samples:</h4>

                <div class="layout__padding__bottom-6px">
                    <span class="text__colour-red layout__padding__right-2 text__style-bold-900">t:&#09;&#09;&#09;&#09;&#09;</span>
                    <span class="text__colour-teal text__style-bold-900">01865 712211</span>
                    <br>
                </div>

                <div>
                    <span class="text__colour-red layout__padding__right-2 text__style-bold-900">e:&#09;&#09;&#09;&#09;&#09;</span>
                    <span>
                        <a href="mailto:orders@printconcern.co.uk" class="link__colour-teal text__style-bold-900" target="_top">orders@printconcern.co.uk</a>
                    </span>
                </div>

                <span class="layout__border__top-1px-909399 layout__position-left layout__width-100 layout__margin-25-0">
                <h4 class="layout__margin__top-20px">Or if you'd like a callback, complete this form:</h4>

                    <el-form :model="callbackRequest" status-icon ref="callbackRequest"
                                :rules="rules"
                                class="layout__padding-clear">
                        <el-form-item prop="name">
                            <div class="layout__padding-8-0">Name<span class="text__colour-red">*</span></div>
                            <el-input class=" layout__padding-8-0 layout__position-right" placeholder="name"
                                      v-model="callbackRequest.name" clearable
                                      autofocus></el-input>
                        </el-form-item>
                        <div class="component__columns-2__no-padding layout__padding__right-10px">
                            <el-form-item prop="company">
                                <div class="layout__padding-8-0">Company<span class="text__colour-red">*</span></div>
                                <el-input class=" layout__padding-8-0 layout__position-right" placeholder="company"
                                        v-model="callbackRequest.company" clearable></el-input>
                            </el-form-item>
                            <el-form-item prop="email">
                                <div class="layout__padding-8-0">Email Address<span class="text__colour-red">*</span></div>
                                <el-input class=" layout__padding-8-0 layout__position-right" placeholder="email"
                                        v-model="callbackRequest.email" clearable></el-input>
                            </el-form-item>
                        </div>
                        <div class="component__columns-2__no-padding">
                            <el-form-item prop="postcode">
                                <div class="layout__padding-8-0">Postcode<span class="text__colour-red">*</span></div>
                                <el-input class=" layout__padding-8-0 layout__position-right" placeholder="postcode"
                                        v-model="callbackRequest.postcode" clearable></el-input>
                            </el-form-item>
                            <el-form-item prop="phoneNumber" class="layout__padding-clear">
                                <div class="layout__padding-8-0">Phone Number<span class="text__colour-red">*</span></div>
                                <el-input class=" layout__padding-8-0 layout__position-right" placeholder="phone number"
                                        v-model="callbackRequest.phoneNumber" clearable></el-input>
                            </el-form-item>
                        </div>

                        <el-form-item prop="topicOfInterest" class="layout__padding-clear">
                            <div class="layout__padding-8-0">Interested In</div>
                            <el-select v-model="callbackRequest.topicOfInterest" filterable placeholder="Select a topic"
                                    clearable>
                                <el-option-group
                                        v-for="group in topics"
                                        :key="group.label"
                                        :label="group.label">
                                    <el-option
                                            v-for="item in group.options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>

                        <el-form-item prop="message" class="">
                            <div class="layout__padding-8-0">Message<span
                                    class="text__colour-red">*</span></div>
                            <el-input type="textarea" :rows="3"
                                        v-model="callbackRequest.message"></el-input>
                        </el-form-item>
                            <div v-show="showRecaptcha === true">
                                <vue-recaptcha
                                        ref="recaptcha"
                                        :key="recaptchaKey"
                                        @verify="onVerify"
                                        @expired="onExpired"
                                        :sitekey="'6Lfg2qIUAAAAADKlBXuXz-tPxFAheAyPTQoevfUk'">
                                </vue-recaptcha>
                            </div>
                            <div class="layout__padding-20-0">
                                <el-button
                                        class="button-red button layout__width-150px layout__position-left"
                                        :disabled="recaptchaNotComplete || isLoading"
                                        v-on:click="sendEmail('callbackRequest')">Submit</el-button>
                            </div>
                    </el-form>
                </span>

            </div>
        </div>
        
        <el-dialog
            :visible.sync="showSuccessMessage"
          width="60%"
        >
            <div
              class="component__message-base component__message-success"
              style="float: none; margin: 0; white-space: normal;"
            >
                Thank you for reaching out to our team, we will get back to you within 24 hours
            </div>
        </el-dialog>


    </div>

</template>

<script>
    import Router from '../router';
    import Axios from 'axios';
    import VueRecaptcha from 'vue-recaptcha';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: "contact",
        mixins: [axios],
        components: {
            VueRecaptcha
        },
        data() {
            return {
                showSuccessMessage: false,
                recaptchaKey: 0,
                isLoading: false,
                callbackRequest: null,
                recaptchaNotComplete: true,
                showRecaptcha: true,
                topics: [{
                    label: 'Products',
                    options: [{
                        value: 'Print',
                        label: 'Print'
                    },
                        {
                            value: 'Digital',
                            label: 'Digital'
                        },
                        {
                            value: 'Template Collections',
                            label: 'Template Collections'
                        },
                        {
                            value: 'Packages',
                            label: 'Packages'
                        }
                    ]
                }, {
                    label: 'Services',
                    options: [{
                        value: 'Design Studio',
                        label: 'Design Studio'
                    }, {
                        value: 'Land & New Homes',
                        label: 'Land & New Homes'
                    }, {
                        value: 'Marketing Toolkit',
                        label: 'Marketing Toolkit'
                    }, {
                        value: 'Photofixr',
                        label: 'Photofixr'
                    }]
                }],
                rules: {
                    name: [{
                        required: true, message: 'Name required', trigger: 'blur'
                    }],
                    company: [{
                        required: true, message: 'Company required', trigger: 'blur'
                    }],
                    postcode: [{
                        required: true, message: 'Postcode required', trigger: 'blur'
                    }],
                    email: [{
                        required: true, message: 'Email Address required', trigger: 'blur'
                    }],
                    phoneNumber: [{
                        required: true, message: 'Phone Number required', trigger: 'blur'
                    }],
                    message: [{
                        required: true, message: 'Message required', trigger: 'blur'
                    }]
                }
            }
        },
        mounted() {
            this.resetCallbackRequest();
            if (`${process.env.VUE_APP_ENVIRONMENT}` === 'dev' || `${process.env.VUE_APP_ENVIRONMENT}` === 'qa') {
                this.showRecaptcha = false;
                this.recaptchaNotComplete = false;
            }
        },
        methods: {
            sendEmail(callbackRequest) {
                // :disabled="recaptchaNotComplete"

                this.$refs[callbackRequest].validate((valid) => {
                    if (valid) {
                        this.isLoading = true;

                        const submitContactUs = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Communication/ContactUs`

                        console.log(submitContactUs)
                        console.log(this.callbackRequest)
                        Axios.post(submitContactUs, this.callbackRequest, this.returnHeaderNoToken())
                            .then(response => {
                                console.log(typeof response.data.success)
                                console.log(response.data.success === true)
                                   this.isLoading = false;

                                if (response.data.success === true) {
                                    this.success = true
                                    this.showSuccessMessage = true;
                                    this.resetCallbackRequest();
                                    this.recaptchaKey += 1;
                                    this.$refs[callbackRequest].resetFields();

                                    // need to signpost on the site thank you for submitting your request
                                }
                            })
                          .catch(() => {
                              this.isLoading = false;
                          })


                    } else {
                        return false;
                    }
                })
            },
            onSubmit: function () {
                this.$refs.invisibleRecaptcha.execute()
            },
            onVerify: function (response) {
                console.log('Verify: ' + response)
                this.recaptchaNotComplete = false
            },
            onExpired: function () {
                this.recaptchaKey += 1;
                console.log('Expired')
            },
            resetRecaptcha() {
                this.$refs.recaptcha.reset() // Direct call reset method
            },
            resetCallbackRequest() {
                this.callbackRequest = {
                    name: '',
                      company: '',
                      postcode: '',
                      email: '',
                      phoneNumber: '',
                      topicOfInterest: '',
                      message: '',
                      success: false,
                };
            },
        }
    };
</script>